import React from "react";
import "../css/pop-subj.css";
import { ReactComponent as Dots } from "../assets/images/sect2-dots.svg";
import { ReactComponent as BgPattern } from "../assets/images/sect2-radial-pattern.svg";
// importing list icons
import { ReactComponent as MatIcon } from "../assets/icons/main-sect2/math-operator.svg";
import { ReactComponent as EngIcon } from "../assets/icons/main-sect2/alphabet.svg";
import { ReactComponent as GovIcon } from "../assets/icons/main-sect2/scales.svg";
import { ReactComponent as BioIcon } from "../assets/icons/main-sect2/cactus.svg";
import { ReactComponent as PhyIcon } from "../assets/icons/main-sect2/lightning-slash.svg";
import { ReactComponent as EcoIcon } from "../assets/icons/main-sect2/currency-ngn.svg";
// importing svg color
import { ReactComponent as BgImgP } from "../assets/images/sect2-bg-purple.svg";
import { ReactComponent as BgImgY } from "../assets/images/sect2-bg-yellow.svg";
import { ReactComponent as BgImgB } from "../assets/images/sect2-bg-black.svg";
import { ReactComponent as BgImgG } from "../assets/images/sect2-bg-green.svg";
import { ReactComponent as BgImgD } from "../assets/images/sect2-bg-dark-blue.svg";
import { ReactComponent as BgImgL } from "../assets/images/sect2-bg-light-blue.svg";

import { ReactComponent as LowerDots } from "../assets/images/sect2-lower-dots.svg";

const PopSubj = () => {
  return (
    <ul id="popular-subj" className="sect2-subject-details">
      <Dots id="dots" className="abs" />
      <li className="subject-card">
        <BgPattern className="abs bg-pattern" />
        <BgImgP className="abs curved-bg" />
        <MatIcon className="subject-icon" />
        <div>
          <span>Mathematics</span>
          <span>123 subject/courses</span>
        </div>
      </li>
      <li className="subject-card">
        <BgPattern className="abs bg-pattern" />
        <BgImgY className="abs curved-bg" />
        <EngIcon className="subject-icon" />
        <div>
          <span>English language</span>
          <span>123 subject/courses</span>
        </div>
      </li>
      <li className="subject-card">
        <BgPattern className="abs bg-pattern" />
        <BgImgB className="abs curved-bg" />
        <GovIcon className="subject-icon" />
        <div>
          <span>Government</span>
          <span>123 subject/courses</span>
        </div>
      </li>
      <li className="subject-card">
        <BgPattern className="abs bg-pattern" />
        <BgImgG className="abs curved-bg" />
        <BioIcon className="subject-icon" />
        <div>
          <span>Biology</span>
          <span>123 subject/courses</span>
        </div>
      </li>
      <li className="subject-card">
        <BgPattern className="abs bg-pattern" />
        <BgImgD className="abs curved-bg" />
        <PhyIcon className="subject-icon" />
        <div>
          <span>Physics</span>
          <span>123 subject/courses</span>
        </div>
      </li>
      <li className="subject-card">
        <BgPattern className="abs bg-pattern" />
        <BgImgL className="abs curved-bg" />
        <EcoIcon className="subject-icon" />
        <div>
          <span>Economics</span>
          <span>123 subject/courses</span>
        </div>
      </li>
      <LowerDots id="lower-dots" className="abs" />
    </ul>
  );
};

export default PopSubj;
